
export function isContentValid(action: any) {
  //action is content where we check for contentids
  return action?.actionBody?.contentIds?.length && action?.actionBody?.body?.[0]?.payload?.data?.contentId?.value !== '';
}
